import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
export type SwipeDirection = 'left' | 'right' | 'up' | 'down';

@Directive({
  selector: '[libSwipe]',
  standalone: true,
})
export class SwipeDirective {
  pos!: { x: number; y: number };
  time!: number;
  swiping = false;
  scrolled = false;
  touchStartPos: { x: number; y: number };
  @Input() swipeMode: 'horizontal' | 'vertical' = 'horizontal';
  @Output() onSwipe: EventEmitter<SwipeDirection> = new EventEmitter();
  @Output() onSwipeEvent: EventEmitter<string> = new EventEmitter();
  @Output() onChangeOffset: EventEmitter<{ x: number; y: number }> = new EventEmitter();

  @HostListener('touchstart', ['$event']) touchStart(event: TouchEvent) {
    this.scrolled = false;
    const touch = event.changedTouches[0];
    if (!touch) return;
    this.pos = {
      x: event.changedTouches[0].clientX,
      y: event.changedTouches[0].clientY,
    };
    this.time = Date.now();
    this.onSwipeEvent.emit('start');
    this.touchStartPos = { x: touch.clientX, y: touch.clientY };
    this.swiping = false;
  }

  @HostListener('touchmove', ['$event']) touchMove(event: TouchEvent) {
    const touch = event.changedTouches[0];
    if (!touch) return;

    if (!this.swiping && this.swipeMode === 'horizontal') {
      const pos = { x: touch.clientX, y: touch.clientY };
      if (!this.touchStartPos) return;
      const moved = { x: Math.abs(pos.x - this.touchStartPos.x), y: Math.abs(pos.y - this.touchStartPos.y) };
      if (moved.y > moved.x || moved.x < 5) return;
    }
    this.swiping = true;
    event.preventDefault();
    const x = touch.clientX;
    const y = touch.clientY;
    const offsetX = x - this.pos.x;
    const offsetY = y - this.pos.y;
    this.onChangeOffset.emit({ x: offsetX, y: offsetY });
  }

  @HostListener('touchend', ['$event']) touchEnd(event: TouchEvent) {
    const direction = this.getDirection(event);
    if (direction) this.onSwipe.emit(direction);
    this.onChangeOffset.emit({ x: 0, y: 0 });
    this.onSwipeEvent.emit('end');
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.scrolled = true;
  }

  private getDirection(event: TouchEvent) {
    if (!this.swiping) return undefined;
    if (this.scrolled) return undefined;
    if (!event.changedTouches[0]) return undefined;
    const pos = {
      x: event.changedTouches[0].clientX,
      y: event.changedTouches[0].clientY,
    };
    const moved = { x: pos.x - this.pos.x, y: pos.y - this.pos.y };
    const duration = Date.now() - this.time;
    if (duration > 700) return undefined;
    const axis = Math.abs(moved.x) > Math.abs(moved.y) ? 'x' : 'y';
    if (Math.abs(moved[axis]) < 30) return undefined;
    return axis === 'x' ? (moved[axis] > 0 ? 'left' : 'right') : moved[axis] > 0 ? 'down' : 'up';
  }
}
